import { Chip } from '@mui/material';
import { alpha } from '@mui/material/styles';

const labels = {
	pending: 'Pending',
	submitted: 'Submitted',
} as const;

const colors = {
	pending: '#FEF08A',
	submitted: '#6EE7B7',
} as const;

type QuestionnaireStatusValue = keyof typeof labels;

interface QuestionnaireStatusStatusProps {
	status: QuestionnaireStatusValue;
	clickable?: boolean;
	onClick?: (event: React.MouseEvent<HTMLDivElement>) => void;
	correlationId?: string | number;
}

export const QuestionnaireStatus: React.FC<QuestionnaireStatusStatusProps> = ({ status, clickable = false, onClick, correlationId }) => {
	const onHover = clickable
		? {
				':hover': {
					cursor: 'pointer',
					backgroundColor: alpha(colors[status], 0.5),
				},
			}
		: {};

	return (
		<Chip
			label={labels[status]}
			onClick={onClick}
			clickable={clickable}
			sx={{
				backgroundColor: colors[status],
				color: '#000',
				fontWeight: 'bold',
				width: { xs: 90, sm: 100, md: 110 },
				fontSize: { xs: '0.65rem', sm: '0.7rem', md: '0.8rem' },
				borderRadius: 5,
				...onHover,
				'&.MuiChip-root': {
					borderRadius: '5px',
				},
			}}
			data-correlation-id={correlationId}
		/>
	);
};
